import {Writable} from 'stream'
import moment from 'moment'

const HOUR = 60 * 60 * 1000

export default class PlatformApi {
  constructor (events) {
    events.once('init', this.init.bind(this))
    this.currentRequestId = 0
    this.requests = new Map()
  }

  init (namePrefix, streamingClient) {
    this.lookupStream = streamingClient.create({
      name: `${namePrefix}platform-api`,
      path: 'platform-api/api'
    })

    const requestResolver = Writable({
      objectMode: true,
      write: ({requestId, error, result}, enc, next) => {
        const promise = this.requests.get(requestId)
        if (!promise) { return }
        if (error) {
          promise.reject(error)
        } else {
          promise.resolve(result)
        }
        this.requests.delete(requestId)
        next()
      }
    })

    this.lookupStream.pipe(requestResolver)
  }

  getNextRequestId () {
    this.currentRequestId += 1
    return this.currentRequestId
  }

  sendRequest (action, data) {
    const requestId = this.getNextRequestId()
    const requestWrapper = {requestId, action, data}
    return new Promise((resolve, reject) => {
      this.requests.set(requestId, {resolve, reject})
      this.lookupStream.writeData(requestWrapper)
    })
  }

  lookup ({type, id, params}) {
    return this.sendRequest('lookup', {type, id, params})
  }

  search (type, params) {
    return this.sendRequest('search', {type, params})
  }

  decodedPcap ({flows}) {
    return this.sendRequest('decoded-pcap', {flows})
  }

  listDevices (paramsInput = {}) {
    const now = Date.now()
    const startTime = now - 2 * HOUR
    const defaults = {
      q: `occurredAt:[${startTime} TO ${now}]`,
      start: 0,
      rows: 50,
      sort: 'risk desc'
    }
    const params = {...defaults, ...paramsInput}
    return this.search('devices', params)
  }

  killboxQuery (paramsInput = {}) {
    const startedAt = moment().subtract(1, 'month').startOf('hour').valueOf()
    const defaults = {
      q: `killChainStages:[Recon TO *] AND startedAt:[${startedAt} TO *]`,
      start: 0,
      rows: 30,
      sort: 'startedAt desc'
    }
    const params = {...defaults, ...paramsInput}
    return this.search('events', params)
  }
}
